<template>
  <!--
    EpisodeInfoSheet.vue
    The "Episode info" bottom sheet opened by the (i) button in BOTH players:
    MediaPlayer.vue (the playlist player) and EpisodePlayerDialog.vue (the
    quick-play player — the one a list's Play opens, which is what plays audio
    episodes; it had no (i) until the user asked for "a (i) control as is for
    the video player", 2026-09-15). One component so the two can't drift apart.

    The body is EpisodeInfoContent.vue — the SAME one the episode context
    menu's info dialog shows (description, notes, AI summary, transcript,
    details table). Until 2026-10-05 this sheet had its own reduced version
    (title, podcast · date · duration, description), reported as "the info
    shown is incomplete — make them homogeneous".
  -->
  <v-bottom-sheet :model-value="modelValue" inset @update:model-value="emit('update:modelValue', $event)">
    <v-card class="info-sheet mx-auto">
      <!-- Header: the episode title (wraps instead of being cut off) + close -->
      <v-card-title class="d-flex align-start py-3">
        <v-icon class="mr-2 mt-1">mdi-information-outline</v-icon>
        <span class="info-title text-subtitle-1 font-weight-medium">{{ episode?.episode_title || episode?.title || "Episode info" }}</span>
        <v-spacer></v-spacer>
        <v-btn
          icon="mdi-close"
          variant="text"
          size="small"
          aria-label="Close info"
          @click="emit('update:modelValue', false)"
        ></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <!-- The shared body; `active` follows the sheet so the details are
           fetched when it opens and cleared when it closes -->
      <v-card-text class="info-body">
        <EpisodeInfoContent :episode="episode" :active="modelValue" />
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script setup>
import EpisodeInfoContent from "@/components/EpisodeInfoContent.vue";

defineProps({
  // Whether the sheet is open (v-model)
  modelValue: { type: Boolean, default: false },
  // The episode being played (list-row shape: at least id, title /
  // episode_title; the rest comes from GET /episode/details/:id)
  episode: { type: Object, default: null },
});

const emit = defineEmits(["update:modelValue"]);
</script>

<style scoped>
.info-sheet {
  width: 100%;
}
/* Title wraps on several lines rather than being truncated */
.info-title {
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
}
/* Cap the body height so the long sections (description, transcript, details)
   scroll within the sheet instead of pushing it off-screen. */
.info-body {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
